import Data from "./Data.js";
import Renders from "./Renders.js";
import Charts from './Charts.js';

export function copyToClipboard (text)
{
    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(() => {
            showSnackbar(__('text_copied_url_successful'), 'success');
        }).catch(err => {
            showSnackbar(__('text_failed_to_copy'));
        });
    } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
            const successful = document.execCommand('copy');
            if (!successful) {
                showSnackbar(__('text_failed_to_copy'));
            } else {
                showSnackbar(__('text_copied_url_successful'), 'success');
            }
        } catch (err) {
            showSnackbar(__('text_failed_to_copy'));
        }

        document.body.removeChild(textarea);
    }
}

let snackbarTimeout;

export function showSnackbar(message, type = 'error', redirectTo = undefined, translateAfter = false)
{
    if (redirectTo) {
        localStorage.setItem('bsense_snackbar', JSON.stringify({message, type, translateAfter}));
        window.location.href = redirectTo;
        return;
    }

    const duration = 5000;
    const snackbar = document.getElementById('snackbar');
    snackbar.style.setProperty('--snackbar-duration', `${duration}ms`);
    snackbar.classList.remove('error', 'success', 'warning');

    const milo = document.querySelector('.snackbar__milo');
    milo.src = milo.src.replace(/milo_(success|warning|error)\.webp$/, `milo_${type}.webp`);

    const icon = snackbar.querySelector('span');

    icon.classList.remove('icon--error', 'icon--warning', 'icon--success');
    icon.classList.add('icon--' + type);

    clearTimeout(snackbarTimeout);
    snackbar.classList.remove('show');
    void snackbar.offsetHeight;

    snackbar.querySelector('p').innerHTML = message;
    snackbar.classList.add(type);

    setTimeout(() => {
        snackbar.classList.add('show');
    }, 100);

    snackbarTimeout = setTimeout(() => {
        snackbar.classList.remove('show');
    }, duration);
}

export function closeSnackbar()
{
    const snackbar = document.getElementById('snackbar');

    if (snackbar.classList.contains('show')) {
        clearTimeout(snackbarTimeout);
        snackbar.classList.remove('show');
        void snackbar.offsetHeight;
    }
}

export function resetTooltip()
{
    const tooltip = document.getElementById('tooltip');
    tooltip.style.opacity = 0;
    tooltip.style.transform = 'translate(-100px, 0)';
    tooltip.textContent = null;
    tooltip.setAttribute('aria-hidden', 'true');
}

export function goToTop()
{
    document.getElementById('to-top').blur();

    const main = document.querySelector('main');

    main.scrollTo({
        top: 150,
        behavior: 'instant'
    });

    requestAnimationFrame(() => {
        main.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}

export function toggleQuickMenu() {
    const main = document.querySelector('main');
    const element = document.getElementById('quick-menu');
    // const toTop = document.getElementById('to-top');

    if (!main || !element) {
        return;
    }
    //
    // const scrollOffset = 20;
    // let lastScrollPosition = main.scrollTop;
    // let isKeyboardOpen = false;
    //
    // document.addEventListener('touchstart', () => {
    //     lastScrollPosition = main.scrollTop;
    // }, { passive: true });
    //
    // document.addEventListener('focusin', (e) => {
    //     if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) {
    //         isKeyboardOpen = true;
    //         hideMenu();
    //     }
    // });
    //
    // document.addEventListener('focusout', (e) => {
    //     if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName)) {
    //         setTimeout(() => {
    //             isKeyboardOpen = false;
    //             lastScrollPosition = main.scrollTop;
    //             showMenu();
    //         }, 400);
    //     }
    // });

    let isKeyboardOpen = false;
    let lastScrollPosition = 0;

    const hideMenu = () => {
        element.setAttribute('tabindex', "-1");
        element.setAttribute('aria-hidden', "true");
        element.classList.remove('show');
        element.blur();
    };

    const showMenu = () => {
        element.setAttribute('tabindex', "0");
        element.setAttribute('aria-hidden', "false");
        element.classList.add('show');
    };

    if (main.scrollTop >= 0) {
        showMenu();
        // toTop.classList.add('disabled');
    }

    if ('visualViewport' in window) {
        const initialViewportHeight = window.visualViewport.height;

        window.visualViewport.addEventListener('resize', () => {
            const heightDifference = initialViewportHeight - window.visualViewport.height;
            const isKeyboardVisible = heightDifference > 150;

            if (isKeyboardVisible && !isKeyboardOpen) {
                isKeyboardOpen = true;
                // document.body.classList.add('keyboard-open');
                hideMenu();
            } else if (!isKeyboardVisible && isKeyboardOpen) {
                isKeyboardOpen = false;
                // document.body.classList.remove('keyboard-open');
                lastScrollPosition = main.scrollTop;
                showMenu();
            }
        });
    }

    // main.addEventListener('scroll', () => {
    //     if (isKeyboardOpen || document.querySelector('.card__box--fullscreen')) {
    //         return;
    //     }

        // const currentScrollPosition = main.scrollTop;
        // const scrollDelta = currentScrollPosition - lastScrollPosition;
        //
        // const isAtBottom = Math.ceil(currentScrollPosition + main.clientHeight) >= (main.scrollHeight - 60);
        //
        // if (isAtBottom) {
        //     showMenu();
        //     toTop.classList.remove('disabled');
        //     lastScrollPosition = currentScrollPosition;
        //     return;
        // }
        //
        // if (currentScrollPosition < 0) {
        //     hideMenu();
        //     lastScrollPosition = 0;
        //     return;
        // }
        //
        // if (scrollDelta > scrollOffset) {
        //     hideMenu();
        //     lastScrollPosition = currentScrollPosition;
        // } else if (scrollDelta < -scrollOffset || currentScrollPosition === 0) {
        //     showMenu();
        //     lastScrollPosition = currentScrollPosition;
        // }
        //
        // if (currentScrollPosition >= 400) {
        //     toTop.classList.remove('disabled');
        // } else {
        //     toTop.classList.add('disabled');
        // }
    // });
}

export function isValidEmail(email)
{
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
}

export function renderFEerrors(form, errors)
{
    form.classList.add('form__error');
    for(let fieldName in errors) {
        let field = form.querySelector('span[data-field="' + fieldName + '"]');

        if (field) {
            field.closest('.form__group').classList.add('form__group--error');
            field.textContent = errors[fieldName];
        }
    }

    form.querySelector('.form__group--error')?.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
    });
}

export function renderBEerrors(form, errors)
{
    form.classList.add('form__error');
    for (let fieldName in errors) {
        let field = form.querySelector('span[data-field="' + fieldName + '"]');

        if (field) {
            field.closest('.form__group').classList.add('form__group--error');
            field.textContent = errors[fieldName];
        }
    }

    form.querySelector('.form__group--error')?.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
    });
}

export function toggleLoadingBar()
{
    document.body.classList.toggle('global--loading');

    const loadingBarElement = document.getElementById('loading-bar');

    if (document.body.classList.contains('global--loading')) {
        if (loadingBarElement) {
            loadingBarElement.setAttribute('role', 'progressbar');
            loadingBarElement.setAttribute('aria-valuemin', '0');
            loadingBarElement.setAttribute('aria-valuemax', '0');
            loadingBarElement.setAttribute('aria-hidden', 'false');
        }
    } else {
        if (loadingBarElement) {
            loadingBarElement.removeAttribute('role');
            loadingBarElement.removeAttribute('aria-valuemin');
            loadingBarElement.removeAttribute('aria-valuemax');
            loadingBarElement.setAttribute('aria-hidden', 'true');
        }
    }
}

export function toggleTheme()
{
    if (typeof document.documentElement.dataset.theme !== 'undefined') {
        if (document.documentElement.dataset.theme === 'light') {
            document.documentElement.dataset.theme = 'dark';
        } else {
            document.documentElement.dataset.theme = 'light'
        }
    } else {
        document.documentElement.dataset.theme = 'dark';
    }

    localStorage.setItem('theme', document.documentElement.dataset.theme);
}

export function formsSync(modal, signal)
{
    const formsSnapshots = {};
    const forms = modal?.querySelectorAll('form') || document.querySelectorAll('form');

    if (forms.length) {
        forms.forEach(form => {
            if ("skipSync" in form.dataset) {
                return;
            }

            formsSnapshots[form.getAttribute('id')] = JSON.stringify(Object.fromEntries(new FormData(form)));
            const formButton = modal?.querySelector('.button--disabled') || form.querySelector('.button--disabled');

            const events = ['input'];

            events.forEach(event => {
                form.addEventListener(event, e => {
                    const target = e.target;
                    if (!target.closest('.dropdown__item--header')) {
                        const formGroup = target.closest('.form__group');
                        if (formGroup.classList.contains('form__group--error')) {
                            formGroup.classList.remove('form__group--error');
                            formGroup.querySelector('.error').textContent = '';
                        }

                        if (JSON.stringify(Object.fromEntries(new FormData(form))) !== formsSnapshots[form.getAttribute('id')]) {
                            formButton?.classList.remove('button--disabled');
                        } else {
                            formButton?.classList.add('button--disabled');

                            form.querySelectorAll('.form__group').forEach(fg => {
                                if (fg.classList.contains('form__group--error')) {
                                    fg.classList.remove('form__group--error');
                                    fg.querySelector('.error').textContent = '';
                                }
                            });
                        }
                    }
                }, {signal});
            });
        })
    }
}
export function toggleFullscreen(element)
{
    // It caused a bug with the keyboard on some devices
    // const supportNative = document.fullscreenEnabled || document.webkitFullscreenEnabled;
    const supportNative = false;

    if (supportNative) {
        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
            if (element.requestFullscreen) {
                element.requestFullscreen().then(() => {
                    element.classList.add('card__box--max-height');
                    element.querySelector('.icon--fullscreen').classList.replace('icon--fullscreen', 'icon--exit-fullscreen');
                });
            } else if (element.webkitFullscreen) {
                element.webkitFullscreen().then(() => {
                    element.classList.add('card__box--max-height');
                    element.querySelector('.icon--fullscreen').classList.replace('icon--fullscreen', 'icon--exit-fullscreen');
                });
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen().then(() => {
                    element.classList.remove('card__box--max-height');
                    element.querySelector('.icon--exit-fullscreen').classList.replace('icon--exit-fullscreen', 'icon--fullscreen');
                });
            } else if (document.webkitFullscreen) {
                document.webkitFullscreen().then(() => {
                    element.classList.remove('card__box--max-height');
                    element.querySelector('.icon--exit-fullscreen').classList.replace('icon--exit-fullscreen', 'icon--fullscreen');
                });
            }
        }
    } else {
        element.classList.toggle('card__box--fullscreen');

        if (element.querySelector('.icon--fullscreen')) {
            element.querySelector('.icon--fullscreen').classList.replace('icon--fullscreen', 'icon--exit-fullscreen');

            BS_EVENTS.was_quick_menu_visible = document.getElementById('quick-menu').classList.contains('show');

            if (BS_EVENTS.was_quick_menu_visible) {
                document.getElementById('quick-menu').classList.remove('show');
            }

        } else {
            element.querySelector('.icon--exit-fullscreen').classList.replace('icon--exit-fullscreen', 'icon--fullscreen');

            if (BS_EVENTS.was_quick_menu_visible) {
                document.getElementById('quick-menu').classList.add('show');
                delete BS_EVENTS.was_quick_menu_visible;
            }
        }
    }
}

export function fullscreenEventListener()
{
    const changeEvents = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'];

    changeEvents.forEach(eventType => {
        document.addEventListener(eventType, () => {
            const isFullscreen = document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;

            if (!isFullscreen) {
                const element = document.querySelector('.card__box--max-height');

                if (element) {
                    element.classList.remove('card__box--max-height');
                    element.querySelector('.icon--exit-fullscreen').classList.replace('icon--exit-fullscreen', 'icon--fullscreen');
                }
            }
        });
    });
}

export function togglePlannerCards(card)
{
    card.classList.toggle('planner-card--opened');

    if (card.classList.contains('planner-card--opened')) {
        card.classList.remove('border-line');
    } else {
        card.classList.add('border-line');
    }
}

export function toggleMonthStatus(target)
{
    const categoryId = target.closest('[data-category-id]').dataset.categoryId;
    const month = parseInt(target.closest('[data-month]').dataset.month);
    const amount = parseInt(target.closest('[data-amount]').dataset.amount);
    const isCompactView = target.closest('#compact_view');
    const compactViewTarget = !isCompactView ? target.closest('.container').querySelector('#compact_view [data-category-id="' + categoryId + '"] [data-month="' + month + '"] input[name="toggle"]') : target;

    const line = compactViewTarget.closest('.planner-card__line');
    const year = parseInt(target.closest('.container').querySelector('.dropdown__selected').textContent);
    const checkedState = target.checked;

    const data = new Data();

    data.toggleMonthStatus({category_id: categoryId, year: year, month: month, status: Number(checkedState)}, year, month).then((result) => {
        if (result.status === 'success' && !result.error) {
            line.classList.toggle('planner-card__line--disabled');
            line.dataset.active = (Number(line.dataset.active) === 1 ? 0 : 1);

            if (Number(line.dataset.active) === 1) {
                EXTRA_DATA.planner.budget[Number(month) - 1] += amount;
            } else {
                EXTRA_DATA.planner.budget[Number(month) - 1] -= amount;
            }
            window.dispatchEvent(new Event('budgetChanged'));

            const fullView = target.closest('.container').querySelector('#full_view');

            if (fullView) {
                const fullViewCell = fullView.querySelector('[data-category-id="' + categoryId + '"] [data-month="' + month + '"]');

                fullViewCell.dataset.activeAmount = line.dataset.active;
                fullViewCell.querySelector('.num .mask').classList.toggle('disabled')

                const fullViewCellIndex = fullViewCell.cellIndex;
                const fullViewRow = fullViewCell.closest('tr');
                const fullViewTable = fullViewCell.closest('table');

                // update horizontal total
                let totalAmount = 0;
                fullViewRow.querySelectorAll('td[data-active-amount="1"]').forEach(item => {
                    totalAmount += parseFloat(item.dataset.amount ?? 0)
                });

                fullViewRow.querySelector('.yearly_totals .total_budget').textContent = numberFormat(totalAmount);

                // update vertical totals
                const allRows = Array.from(fullViewTable.querySelectorAll('tr'));
                const startColumnIndex = fullViewCellIndex;
                const endColumnIndex = fullViewCellIndex;

                for (let columnIndex = startColumnIndex; columnIndex <= endColumnIndex; ++columnIndex) {
                    let totalVerticalAmount = 0;

                    const columnCells = allRows.map(r => r.cells[columnIndex]).filter(Boolean);

                    columnCells.forEach(cell => {
                        if (Number(cell.dataset.activeAmount)) {
                            const foundAmount = cell.querySelector('.num .mask');
                            if (foundAmount) {
                                totalVerticalAmount += parseFloat(cell.dataset.amount ?? 0);
                            }
                        }
                    });

                    const lastCell = columnCells[columnCells.length - 1];
                    lastCell.dataset.amount = totalVerticalAmount;
                    lastCell.querySelector('.total_budget').textContent = numberFormat(totalVerticalAmount);
                }

                // update yearly total
                let yearlyTotal = 0;
                fullViewTable.querySelectorAll('tr:last-child td:not(:last-child)').forEach(item => {
                    yearlyTotal += parseFloat(item.dataset.amount ?? 0);
                });

                fullViewTable.querySelector('tr:last-child td:last-child .total_budget').textContent = numberFormat(yearlyTotal);
            }

            calculateProgress(compactViewTarget.closest('.planner-card'));

            showSnackbar(__('text_saved_successful'), 'success');
        } else {
            target.checked = !checkedState;
        }
    });
}

export function calculateProgress(row)
{
    let amounts = [];
    let totalMonthsWithBudgets = 0;
    let activeMonths = 0;
    row.querySelectorAll('.planner-card__line:not(.planner-card__line--disabled)').forEach(item => {
        ++activeMonths;
        let currentAmount = parseFloat(item.dataset.amount);

        if (currentAmount > 0) {
            amounts.push(currentAmount);
        }
    });

    totalMonthsWithBudgets = amounts.length;
    let progress = (totalMonthsWithBudgets > 0 ? Math.ceil((totalMonthsWithBudgets / activeMonths) * 100) : 0) + '%';
    let animationTime = (totalMonthsWithBudgets > 0 ? '1.2s' : '0s');
    row.querySelector('.progress-bar-fill').setAttribute('style', '--progress-bar-animation-time: ' + animationTime + '; --progress-bar-progress: ' + progress + ';')
    row.querySelector('.progress-bar-fill .progress-bar-text').textContent = progress;
}

export function numberFormat(value)
{
    return (CURRENCY.position === 'before' ? '' + CURRENCY.symbol.trim() : '') + (new Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})).format(value) + (CURRENCY.position === 'after' ? ' ' + CURRENCY.symbol.trim() : '');
}

export function dateFormat(unixTimestamp, ignoreTime = false)
{
    const date = new Date(unixTimestamp * 1000);
    const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: window.USER.timezone
    };

    if (!ignoreTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.hour12 = false;
    }

    const formattedDate = new Intl.DateTimeFormat(SYSTEM_LANGUAGE, options).formatToParts(date);

    const parts = {};
    formattedDate.forEach(({ type, value }) => parts[type] = value);

    const monthName = parts.month.charAt(0).toUpperCase() + parts.month.slice(1);

    return `${parts.day} ${monthName}, ${parts.year}` + (!ignoreTime ? ` ${parts.hour}:${parts.minute}` : '');
}

export function validatePassword(password) {
    const schema = /^(?=.*[\p{Lu}])(?=.*[\p{Ll}])(?=.*[\p{N}])(?=.*[\p{S}\p{P}]).{8,}$/u;
    return schema.test(password);
}

export function getBlock(row) {
    const rows = [...row.parentNode.children];
    const startIndex = rows.indexOf(row);
    const startDepth = Number(row.dataset.depth);

    const block = [row];

    for (let i = startIndex + 1; i < rows.length; i++) {
        const depth = Number(rows[i].dataset.depth);

        if (depth <= startDepth) break;

        block.push(rows[i]);
    }

    return block;
}

export function getOrderedCategories()
{
    const rows = [...document.querySelectorAll('.placeholder__row')];

    return rows.map(row => ({
        id: row.dataset.id,
        position: Number(row.dataset.position),
        parent_id: (row.dataset.parentId ? row.dataset.parentId : null)
    }));
}

export function moveUp(row) {
    const container = row.parentNode;
    const snapshot = [...container.children].map(i => i.cloneNode(true));
    const depth = row.dataset.depth;
    const parentId = row.dataset.parentId || '';
    const siblings = [...container.querySelectorAll('[data-parent-id="' + parentId + '"][data-depth="' + depth +'"]')];
    const currentIndex = siblings.findIndex(el => el === row);

    if (currentIndex === 0) {
        return;
    }

    const previousSibling = siblings[currentIndex - 1];
    const currentBlock = getBlock(row);

    previousSibling.before(...currentBlock);

    const oldPosition = Number(row.dataset.position);
    const newPosition = Number(previousSibling.dataset.position);

    row.dataset.position = newPosition;
    previousSibling.dataset.position = oldPosition;

    const data = new Data();

    data.rearrange({items: getOrderedCategories()}).then(results => {
        if (results.status === 'success' && !results.error) {
            showSnackbar(__('text_saved_successful'), 'success');
        } else {
            container.replaceChildren(...snapshot);
            if (!results.hasOwnProperty("display")) {
                showSnackbar(__('categories.text_failed_revert_to_original'), 'error');
            }
        }
    });
}

export function moveDown(row) {
    const container = row.parentNode;
    const snapshot = [...container.children].map(i => i.cloneNode(true));
    const depth = row.dataset.depth;
    const parentId = row.dataset.parentId || '';
    const siblings = [...container.querySelectorAll('[data-parent-id="' + parentId + '"][data-depth="' + depth +'"]')];
    const currentIndex = siblings.findIndex(el => el === row);

    if (currentIndex === siblings.length - 1) {
        return;
    }

    const nextSibling = siblings[currentIndex + 1];
    const currentBlock = getBlock(row);
    const nextBlock = getBlock(nextSibling);

    nextBlock[nextBlock.length - 1].after(...currentBlock);

    const oldPosition = Number(row.dataset.position);
    const newPosition = Number(nextSibling.dataset.position);

    row.dataset.position = newPosition;
    nextSibling.dataset.position = oldPosition;

    const data = new Data();

    data.rearrange({items: getOrderedCategories()}).then(results => {
        if (results.status === 'success' && !results.error) {
            showSnackbar(__('text_saved_successful'), 'success');
        } else {
            container.replaceChildren(...snapshot);
            if (!results.hasOwnProperty("display")) {
                showSnackbar(__('categories.text_failed_revert_to_original'), 'error');
            }
        }
    });
}

export function moveToTop(row) {
    const container = row.parentNode;
    const snapshot = [...container.children].map(i => i.cloneNode(true));
    const depth = row.dataset.depth;
    const parentId = row.dataset.parentId || '';
    const siblings = [...container.querySelectorAll('[data-parent-id="' + parentId + '"][data-depth="' + depth +'"]')];
    const currentIndex = siblings.findIndex(el => el === row);

    if (currentIndex <= 0) {
        return;
    }

    const movingBlock = getBlock(row);
    const firstSibling = siblings[0];

    for (let i = 0; i < currentIndex; ++i) {
        siblings[i].dataset.position = Number(siblings[i].dataset.position) + 1;
    }

    row.dataset.position = 1;
    firstSibling.before(...movingBlock);

    const data = new Data();

    data.rearrange({items: getOrderedCategories()}).then(results => {
        if (results.status === 'success' && !results.error) {
            showSnackbar(__('text_saved_successful'), 'success');
        } else {
            container.replaceChildren(...snapshot);

            if (!results.hasOwnProperty("display")) {
                showSnackbar(__('categories.text_failed_revert_to_original'), 'error');
            }
        }
    });
}

export function moveToBottom(row) {
    const container = row.parentNode;
    const snapshot = [...container.children].map(i => i.cloneNode(true));
    const depth = row.dataset.depth;
    const parentId = row.dataset.parentId || '';
    const siblings = [...container.querySelectorAll('[data-parent-id="' + parentId + '"][data-depth="' + depth +'"]')];
    const currentIndex = siblings.findIndex(el => el === row);

    if (currentIndex === -1 || currentIndex >= siblings.length - 1) {
        return;
    }

    const movingBlock = getBlock(row);
    const lastSibling = siblings[siblings.length - 1];
    const lastBlock = getBlock(lastSibling);

    for (let i = currentIndex + 1; i < siblings.length; ++i) {
        siblings[i].dataset.position = Number(siblings[i].dataset.position) - 1;
    }

    row.dataset.position = siblings.length;
    lastBlock[lastBlock.length - 1].after(...movingBlock);

    const data = new Data();
    
    data.rearrange({items: getOrderedCategories()}).then(results => {
        if (results.status === 'success' && !results.error) {
            showSnackbar(__('text_saved_successful'), 'success');
        } else {
            container.replaceChildren(...snapshot);
            if (!results.hasOwnProperty("display")) {
                showSnackbar(__('categories.text_failed_revert_to_original'), 'error');
            }
        }
    });
}

export function togglePillBox(target)
{
    const container = target.closest('.pills-container');
    const input = container.querySelector('input');
    target.closest('.pill-box').classList.toggle('pill-box--active');

    input.value = [...container.querySelectorAll('.pill-box--active')].map(item => item.dataset.id).join(',');
    input.dispatchEvent(new Event('input', { bubbles: true }));
}

export function reRenderCategories(target, spaceId)
{
    const section = target.closest('.section');
    const typeDropdown = section.querySelector('.form__group.type .dropdown');
    const categoryDropdown = section.querySelector('.form__group.category .dropdown');
    const categoryDropdownContent = categoryDropdown.querySelector('.dropdown__content');

    categoryDropdown.querySelector('.dropdown__selected span').textContent = __('label_choose_category');
    categoryDropdown.querySelector('.dropdown__selected').dataset.value = '';
    categoryDropdownContent.querySelectorAll('.dropdown__item:not(.dropdown__item--header)').forEach(item => item.remove());
    categoryDropdown.querySelector('.dropdown__value input').value = '';

    EXTRA_DATA[typeDropdown.querySelector('input').value].forEach(item => {
        if (spaceId && !item.space_ids.includes(spaceId)) {
            return;
        }

        let itemHtml =
            `<div class="dropdown__item" data-value="${item.id}">
                            <div class="dropdown__grouped">
                                <span class="text">${item.name}</span>
                                <span class="text">${item.parents_path.join(JOINING_SYMBOL)}</span>
                                ${Number(item.is_shared) === 1
                                    ? `<span class="text"><span class="icon icon--shared-spaces"></span>${item.space_names.split('#,#').join(JOINING_SYMBOL)}</span>`
                                    : ''
                                }
                            </div>
                        </div>`;

        categoryDropdownContent.insertAdjacentHTML('beforeend', itemHtml);
    });

    if (!categoryDropdownContent.querySelectorAll('.dropdown__item:not(.dropdown__item--header)').length) {
        categoryDropdown.classList.add('dropdown--disabled');
    } else {
        categoryDropdown.classList.remove('dropdown--disabled');
    }
}

export function renderFormDependsOnFrequencyType(target)
{
    const now = new Date();
    const form = target.closest('form');
    const type = target.closest('.dropdown__item').dataset.value;

    const frequencyIntervalTarget = form.querySelector('.frequency_interval');
    const dueDayTarget = form.querySelector('.due_day');
    const whenInput = form.querySelector('.when input');

    const otherElements = {
        end_of_month: form.querySelector('.end_of_month'),
        max_runs: form.querySelector('.max_runs'),
        start_after: form.querySelector('.start_after'),
        when: form.querySelector('.when')
    };

    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    frequencyIntervalTarget.querySelector('.dropdown__item--active')?.classList.remove('.dropdown__item--active');
    dueDayTarget.querySelector('.dropdown__item--active')?.classList.remove('.dropdown__item--active');

    const updateDropdown = (target, list, label, defaultText) => {
        target.classList.remove('hide-element');
        target.classList.remove('disabled-element');
        target.querySelector('.dropdown__selected').dataset.value = '';

        if (label) {
            target.querySelector('label').textContent = label;
        }

        if (defaultText) {
            target.querySelector('.dropdown__selected span').textContent = defaultText;
        }

        let content = target.querySelector('.dropdown__content');
        content.innerHTML = list.map((item) => {
            return `
                <div class="dropdown__item" data-value="${item.value}">
                    <span>${item.label}</span>
                </div>
            `;
        }).join('');

        target.querySelector('input').value = null;
    };

    const hideOtherElements = (hide) => {
        Object.values(otherElements).forEach(item => {
            if (hide) {
                item.classList.add('hide-element');
            } else {
                item.classList.remove('hide-element');
            }
        });
    };

    frequencyIntervalTarget.classList.add('hide-element');
    dueDayTarget.classList.add('hide-element');
    otherElements.max_runs.classList.remove('hide-element');

    window.applyPicker(whenInput, {
        noCalendar: true,
        enableTime: true,
        dateFormat: 'H:i'
    }, now);

    if (type === 'once') {
        hideOtherElements(true);

        window.applyPicker(whenInput, {
            noCalendar: false,
            enableTime: true,
            dateFormat: 'Y-m-d H:i'
        }, now);

        otherElements.when.classList.remove('hide-element');

    } else if (type === 'daily') {
        otherElements.start_after.classList.remove('hide-element');
        otherElements.end_of_month.classList.add('hide-element');

    } else if (type === 'weekly') {
        otherElements.start_after.classList.remove('hide-element');
        otherElements.end_of_month.classList.add('hide-element');
        const dayList = days.map((day, i) => ({ label: __('day_' + day.toLowerCase()), value: i + 1}));
        updateDropdown(dueDayTarget, dayList, __('label_day_of_week'), __('label_choose_day'));

    } else if (type === 'monthly') {
        otherElements.start_after.classList.remove('hide-element');
        otherElements.end_of_month.classList.remove('hide-element');
        const dateList = Array.from({length: 31}, (_, i) => ({ label: i + 1, value: i + 1}));
        updateDropdown(dueDayTarget, dateList, __('label_day_of_month'), __('label_choose_day'));

    } else if (type === 'yearly') {
        otherElements.start_after.classList.remove('hide-element');
        otherElements.end_of_month.classList.remove('hide-element');
        const monthList = months.map((month, i) => ({ label: __('month_' + month.toLowerCase()), value: i + 1}));
        const dateList = Array.from({length: 31}, (_, i) => ({ label: i + 1, value: i + 1}));

        updateDropdown(frequencyIntervalTarget, monthList, __('label_month'), __('label_choose_month'));
        updateDropdown(dueDayTarget, dateList, __('label_day'), __('label_choose_day'));
    }

    otherElements.end_of_month.querySelector('input').checked = false;
    form.querySelectorAll('.form__group--error').forEach(item => {
        item.classList.remove('form__group--error');
        item.querySelector('.error').textContent = null;
    });
}

export function applyTemplate(target)
{
    const form = target.closest('form');
    const id = target.closest('[data-value]').dataset.value;

    if (typeof EXTRA_DATA.transaction_templates !== 'undefined' && typeof EXTRA_DATA.transaction_templates[id] !== 'undefined') {
        const template = EXTRA_DATA.transaction_templates[id];

        form.querySelector('.type [data-value="' + template.type + '"]').click();

        const category = form.querySelector('.category [data-value="' + Object.keys(template.categories[0])[0] + '"]');

        if (category) {
            category.click();
            category.closest('.category').click();
        }

        form.querySelector('input#amount').value = template.amount;
        form.querySelector('#comment').value = template.comment;
    }
}

export function toggleInactiveElements(id, active)
{
    document.querySelectorAll('[data-id="' + id + '"]').forEach(item => {
        if (active) {
            item.classList.remove('inactive-element');
        } else {
            item.classList.add('inactive-element');
        }
    })
}

export function truncateCoords(num) {
    const match = num.toString().match(/^-?\d+(?:\.\d{0,6})?/);
    return match ? match[0] : num.toString();
}

export function capitalize(keyword) {
    return keyword.charAt(0).toUpperCase() + keyword.slice(1);
}

export function togglePrivacyMode(target)
{
    const value = target.closest('.privacy-mode-toggle').querySelector('input').checked;

    localStorage.setItem('privacy_mode', value);

    if (value) {
        document.body.classList.add('privacy-mode');
    } else {
        document.body.classList.remove('privacy-mode');
    }

    window.dispatchEvent(new Event('privacyToggled'));
}

export function cancelDeletionOfAccount(target)
{
    const data = new Data();

    data.cancelDeletionOfAccount().then((result) => {
        if (result.status === 'success' && !result.error) {
            const container = target.closest('.container');
            container.querySelector('#delete_account_placeholder').classList.remove('hide-element');
            container.querySelector('#delete_account_placeholder').querySelector('.dropdown__selected span').textContent = 'No';
            container.querySelector('#delete_account_placeholder button').classList.add('button--disabled');
            container?.querySelector('#restore_account_placeholder')?.classList.add('hide-element');

            showSnackbar(__('account.text_cancel_deleting_account'), 'success');
        }
    });
}

export function reorderTemplates(target)
{
    const table = target.closest('.table-container .table');
    const row = target.closest('.table__row');

    const snapshot = Array.from(table.querySelectorAll('.table__row:not(.table__row--header)')).map(r => ({
        element: r,
        position: String(r.dataset.position)
    }));

    const selectedTarget = target.closest('.dropdown__item');
    const currentPosition = row.dataset.position;
    const newPosition = selectedTarget.dataset.value;
    const targetRow = table.querySelector('[data-position="' + newPosition + '"]');
    let items = [];

    if (!targetRow) {
        const data = new Data();
        data.templateByPosition(newPosition).then((result) => {
            if (result.status === 'success' && !result.error && Object.keys(result.data).length) {
                const returnedItem = result.data[Object.keys(result.data)[0]];

                items.push({id: row.dataset.id, position: newPosition});
                items.push({id: returnedItem.template_id, position: currentPosition});

                data.swapTransactionTemplatePositions(items).then((result) => {
                    if (result.status === 'success' && !result.error) {
                        returnedItem.position = currentPosition;

                        const template = document.getElementById('tx-tmp-list-template').content;
                        const templateRow = template.querySelector('.table__row:not(.table__row--header)');
                        const render = new Renders();
                        const fetchedRow = render.transactionTemplate(returnedItem, templateRow.cloneNode(true));

                        fetchedRow.querySelector('.dropdown__item--inactive')?.classList.remove('dropdown__item--inactive');
                        fetchedRow.querySelector('.dropdown__item[data-value="' + newPosition + '"]').classList.add('dropdown__item--inactive');

                        row.replaceWith(fetchedRow);

                        showSnackbar(__('text_saved_successful'), 'success');
                    }
                });
            }
        });
    } else {
        const rectRow = row.getBoundingClientRect();
        const rectTarget = targetRow.getBoundingClientRect();

        row.dataset.position = newPosition;
        row.querySelector('.dropdown__selected .text').textContent = '#' + newPosition;
        items.push({id: row.dataset.id, position: newPosition});

        targetRow.dataset.position = currentPosition;
        targetRow.querySelector('.dropdown__selected .text').textContent = '#' + currentPosition;
        items.push({id: targetRow.dataset.id, position: currentPosition});

        row.querySelector('.dropdown__item--inactive').classList.remove('dropdown__item--inactive');
        row.querySelector('.dropdown__item[data-value="' + newPosition + '"]').classList.add('dropdown__item--inactive');

        targetRow.querySelector('.dropdown__item--inactive').classList.remove('dropdown__item--inactive');
        targetRow.querySelector('.dropdown__item[data-value="' + currentPosition + '"]').classList.add('dropdown__item--inactive');

        const nextSibling = targetRow.nextSibling;
        table.insertBefore(targetRow, row);
        table.insertBefore(row, nextSibling);

        const newRectRow = row.getBoundingClientRect();
        const newRectTarget = targetRow.getBoundingClientRect();
        const deltaYRow = rectRow.top - newRectRow.top;
        const deltaYTarget = rectTarget.top - newRectTarget.top;

        row.style.transform = `translateY(${deltaYRow}px)`;
        row.style.transition = 'none';

        targetRow.style.transform = `translateY(${deltaYTarget}px)`;
        targetRow.style.transition = 'none';

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const duration = 300;
                const easing = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

                row.style.transition = `transform ${duration}ms ${easing}`;
                targetRow.style.transition = `transform ${duration}ms ${easing}`;

                row.style.transform = '';
                targetRow.style.transform = '';
            });
        });

        setTimeout(() => {
            row.style.transition = '';
            targetRow.style.transition = '';
        }, 300);

        const data = new Data();

        data.swapTransactionTemplatePositions(items).then((result) => {
            if (result.status === 'success' && !result.error) {
                showSnackbar(__('text_saved_successful'), 'success');
            } else {
                snapshot.forEach(saved => {
                    saved.element.dataset.position = saved.position;
                    saved.element.querySelector('.dropdown__selected .text').textContent = '#' + saved.position;
                });

                snapshot.forEach(saved => {
                    table.appendChild(saved.element);
                });
            }
        });
    }
}

export function searchInActivate(target)
{
    const placeholder = target.closest('.card__box');
    const prefixClass = '.' + placeholder.dataset.prefixClass;
    const searchInContainer = target.closest('.search-in');
    const searchInput = searchInContainer.querySelector('input');
    const typing = (event) => {
        const value = event.target.value.trim().toLowerCase();

        if (value) {
            placeholder.querySelectorAll(prefixClass + '__title').forEach(item => {
                let texts = '';
                item.querySelectorAll('span').forEach(span => texts += span.textContent);
                texts = texts.replace(/\s+/g, ' ').trim().toLowerCase();

                if (texts.indexOf(value) !== -1) {
                    item.closest(prefixClass).classList.remove('invisible-element');
                } else {
                    item.closest(prefixClass).classList.add('invisible-element');
                }
            });
        } else {
            placeholder.querySelectorAll(prefixClass).forEach(item => item.classList.remove('invisible-element'));
        }

        if (!placeholder.querySelectorAll('.tab__content.active ' + prefixClass + ':not(.invisible-element)').length) {
            placeholder.querySelector('.no_results').classList.remove('hide-element');
        } else {
            placeholder.querySelector('.no_results').classList.add('hide-element');
        }
    };

    searchInContainer.classList.toggle('active');

    if (searchInContainer.classList.contains('active')) {
        searchInput.focus();
        searchInput.addEventListener('input', typing);
        searchInput.onblur = (e) => {
            if (!e.target.value.trim().length) {
                searchInContainer.classList.remove('active');
            }
        };
    } else {
        placeholder.querySelector('.no_results').classList.add('hide-element');
        searchInput.removeEventListener('input', typing);
        placeholder.querySelectorAll('.dashboard-card').forEach(item => item.classList.remove('invisible-element'));
        searchInput.value = '';
        searchInput.blur();
    }
}

export function sanitizeAmountInput(value) {
    if (!value) {
        return '';
    }

    let sanitized = value.replace(/,/g, '.').replace(/[^0-9.-]/g, '');
    const isNegative = sanitized.startsWith('-');
    sanitized = sanitized.replace(/-/g, '');

    if (isNegative) {
        sanitized = '-' + sanitized;
    }

    const parts = sanitized.split('.');
    if (parts.length > 2) {
        sanitized = parts[0] + '.' + parts.slice(1).join('');
    }

    const [integer, fraction] = sanitized.split('.');
    const maxIntDigits = sanitized.startsWith('-') ? 11 : 10;
    const trimmedInteger = integer.slice(0, maxIntDigits);

    if (fraction !== undefined) {
        return `${trimmedInteger}.${fraction.slice(0, 2)}`;
    }

    return trimmedInteger;
}

export function changeDefaultLanguage(target)
{
    const languageCode = target.closest('.dropdown__item').dataset.value.replaceAll('/', '');

    if (languageCode !== SYSTEM_LANGUAGE) {
        const data = new Data();

        data.changeDefaultLanguage(languageCode).then((result) => {
            if (result.status === 'success' && !result.error) {
                // passing only the key
                showSnackbar('text_saved_successful', 'success', window.location.href.replace('/' + SYSTEM_LANGUAGE  + '/', '/' + languageCode + '/'), true);
            } else {
                const dd = target.closest('.dropdown');
                dd.querySelector('.dropdown__selected .text').textContent = dd.querySelector('[data-value="' + SYSTEM_LANGUAGE + '"] .text').textContent;
                showSnackbar(__('text_something_went_wrong'), 'success');
            }
        });
    }

    return;
}

export function searchAndTranslateI18n(data)
{
    if (!data || typeof data !== 'object') {
        if (typeof data === 'string' && data.startsWith('i18n.')) {
            const key = data.slice(5);

            return __(key);
        }

        return data;
    }

    if (Array.isArray(data)) {
        const len = data.length;
        const result = new Array(len);

        for (let i = 0; i < len; i++) {
            result[i] = searchAndTranslateI18n(data[i]);
        }

        return result;
    }

    const result = {};
    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            result[key] = searchAndTranslateI18n(data[key]);
        }
    }

    return result;
}

export function selectAllPills(target)
{
    const container = target.closest('.form__group').querySelector('.pills-container');
    const pills = container.querySelectorAll('.pill-box');
    const allSelected = Array.from(pills).every(pill => pill.classList.contains('pill-box--active'));

    pills.forEach(pill => {
        const isSelected = pill.classList.contains('pill-box--active');

        if (allSelected && isSelected) {
            pill.click();
        } else if (!allSelected && !isSelected) {
            pill.click();
        }
    });
}

export function animateNumber(element, duration = 1000) {
    const target = parseFloat(element.dataset.value.replace(/[^0-9.-]+/g, ""));
    if (isNaN(target)) return;

    const start = 0;
    const startTime = performance.now();
    const span = document.createElement('span');
    span.classList.add('minus');
    span.textContent = '-';

    function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const easeOutProgress = 1 - Math.pow(1 - progress, 3);

        const rawCurrent = start + (target - start) * easeOutProgress;
        const current = Math.max(0, rawCurrent);

        if ('realValue' in element.dataset && 'useMinusSign' in element.dataset) {
            if (parseFloat(element.dataset.realValue) > 0) {
                element.innerText = current.toFixed(2) + '%';
            } else if (parseInt(current) === 0) {
                element.innerText = current.toFixed(2) + '%';
            } else {
                element.innerHTML = '';
                element.appendChild(span);
                element.appendChild(document.createTextNode(current.toFixed(2) + '%'));
            }
        } else if ('usePercent' in element.dataset) {
            element.innerText = current.toFixed(2) + '%';
        } else if ('useNumber' in element.dataset) {
            element.innerText = parseInt(current);
        } else {
            element.innerText = numberFormat(current.toFixed(2));
        }

        if (progress < 1) {
            requestAnimationFrame(update);
        } else {
            if ('realValue' in element.dataset && 'useMinusSign' in element.dataset) {
                if (parseFloat(element.dataset.realValue) > 0) {
                    element.innerText = current.toFixed(2) + '%';
                } else if (parseInt(current) === 0) {
                    element.innerText = current.toFixed(2) + '%';
                } else {
                    element.innerHTML = '';
                    element.appendChild(span);
                    element.appendChild(document.createTextNode(current.toFixed(2) + '%'));
                }
            } else if ('usePercent' in element.dataset) {
                element.innerText = Math.max(0, target).toFixed(2) + '%';
            } else if ('useNumber' in element.dataset) {
                element.innerText = parseInt(target);
            } else {
                element.innerText = numberFormat(Math.max(0, target).toFixed(2));
            }
        }
    }

    requestAnimationFrame(update);
}

export function toggleEye(target)
{
    const passwordContainer = target.closest('.icon__field--password');
    const eyeButton = passwordContainer.querySelector('.toggle-eye');
    const eyeIcon = passwordContainer.querySelector('.icon');
    const passwordInput = passwordContainer.querySelector('input');
    const isPassword = passwordInput.getAttribute('type') === 'password';
    passwordInput.setAttribute('type', isPassword ? 'text' : 'password');

    eyeButton.classList.toggle('is-active', isPassword);

    eyeIcon.classList.toggle('icon--eye', !isPassword);
    eyeIcon.classList.toggle('icon--eye-off', isPassword);

    eyeButton.setAttribute('aria-label', isPassword ? __('label_hide_password') : __('label_show_password'));
    eyeButton.setAttribute('aria-pressed', isPassword ? 'true' : 'false');
}

export function gridLoading(loading = true)
{
    const grid = document.querySelector('.grid__content');

    if (grid) {
        if (loading) {
            grid.classList.add('grid__content--loading');
        } else {
            grid.classList.remove('grid__content--loading');
        }
    }
}

export function checkUncheckAll(target)
{
    const grid = target.closest('.grid');

    grid.querySelectorAll('.grid__content .checkbox__input').forEach(checkbox => checkbox.checked = target.checked);

    prepareSelectedItems();
}

export function prepareSelectedItems()
{
    const grids = document.querySelectorAll('.feature-pages-scanner .grid');
    let payload = {
        selected_items: 0,
        total_amount: 0,
        total_discount: 0,
        items: {}
    };

    if (grids) {
        grids.forEach(grid => {
            const discount = grid.dataset.discount;
            grid.querySelectorAll('.grid__content .checkbox__input').forEach(checkbox => {
                if (checkbox.checked) {
                    ++payload.selected_items;

                    const row = checkbox.closest('.grid__row');
                    const id = row.dataset.id;
                    const receiptId = row.dataset.receiptId;
                    const text = row.querySelector( '#name_' + id).value;
                    const value = row.querySelector('#value_' + id).value;

                    if (!(receiptId in payload.items)) {
                        payload.items[receiptId] = [];
                    }

                    payload.items[receiptId].push({id, text, value});
                    payload.total_amount += parseFloat(value);
                }
            });

            payload.total_discount = parseFloat(discount);
        });
    }

    d(payload);
}

export function processMobileFile(file) {
    return new Promise((resolve) => {
        // If it's not an image or is already small, return original
        if (!file.type.startsWith('image/')) {
            return resolve(file);
        }

        const img = new Image();
        const url = URL.createObjectURL(file);

        img.onload = () => {
            URL.revokeObjectURL(url);

            // Scale down huge mobile camera photos (Max 1920px width/height)
            const MAX_SIZE = 1920;
            let width = img.width;
            let height = img.height;

            if (width > height) {
                if (width > MAX_SIZE) {
                    height *= MAX_SIZE / width;
                    width = MAX_SIZE;
                }
            } else {
                if (height > MAX_SIZE) {
                    width *= MAX_SIZE / height;
                    height = MAX_SIZE;
                }
            }

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);

            // Compress to JPEG at 85% quality
            canvas.toBlob((blob) => {
                if (!blob) return resolve(file); // Fallback
                const compressedFile = new File([blob], file.name || 'receipt.jpg', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                });
                resolve(compressedFile);
            }, 'image/jpeg', 0.85);
        };

        img.onerror = () => resolve(file); // Fallback on error
        img.src = url;
    });
}

export function clearColorPicker(target) {
    const colorPicker = target.closest('.color__picker');
    const colorPickerField = colorPicker.querySelector('#color');
    const colorPickerCircle = colorPicker.querySelector('#color-circle');

    colorPickerCircle.removeAttribute('style');
    colorPickerCircle.classList.add('chromatic-bloom');
    colorPickerField.value = '';

    colorPickerField.dispatchEvent(new Event('input', { bubbles: true }));
}

export function dragAndScrollPlanner() {
    const slider = document.querySelector('#full_view .scrollable-table-wrapper');

    if (slider) {
        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            if ((e.target.closest('.mask') && !e.target.closest('.totals_group')) || e.target.matches('.icon--eye') || e.target.closest('.toggle')) {
                return;
            }

            isDown = true;
            slider.classList.add('is-dragging');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('is-dragging');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('is-dragging');
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX);
            slider.scrollLeft = scrollLeft - walk;
        });
    }
}

export function crosshairHover() {
    document.querySelectorAll('.scrollable-table-wrapper table').forEach(table => {
        const cells = table.querySelectorAll('td, th');

        cells.forEach(cell => {
            cell.addEventListener('mouseenter', () => {
                const row = cell.parentElement;
                const colIndex = Array.from(row.children).indexOf(cell);

                table.querySelectorAll('tr').forEach(tr => {
                    const targetCell = tr.children[colIndex];
                    if (targetCell) {
                        targetCell.classList.add('is-col-hover');
                    }
                });
            });

            cell.addEventListener('mouseleave', () => {
                table.querySelectorAll('.is-col-hover').forEach(c => {
                    c.classList.remove('is-col-hover');
                });
            });
        });
    });
}

export function switchingTabs(target)
{
    const box = target.closest('.card__box');
    const boxContent = box.querySelector('.card__content');
    const selectedTab = [...target.classList].find(i => i.startsWith('tab__'));

    boxContent.querySelector('.tab__content.active').classList.remove('active');
    boxContent.querySelector('.tab__content#' + selectedTab).classList.add('active');

    box.querySelector('.tabs .tab.active').classList.remove('active');
    target.classList.add('active');

    if (box.querySelector('.search-in.active') && box.querySelector('.search-in input').value.trim().length) {
        if (boxContent.querySelectorAll('.tab__content#' + selectedTab + ' .dashboard-card:not(.invisible-element)').length) {
            boxContent.querySelector('.no_results').classList.add('hide-element');
        } else {
            boxContent.querySelector('.no_results').classList.remove('hide-element');
        }
    }
}

export function drawChartForPlanner()
{
    try {
        const chart = new Charts('#planner-chart', {
            type: 'area',
            legend: false,
            categories: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map(month => __('month_' + month.toLowerCase())),
            series: [
                { name: __('label_budget'), data: EXTRA_DATA['planner']['budget'], color: '#A9AEB8'},
                { name: __('label_amount'), data: EXTRA_DATA['planner']['actual'], color: '#50C3F7'},
            ],
        });

        window.addEventListener('privacyToggled', () => {
            chart.update();
        });

        // const updateChartLabels = () => {
        //     chart.update({
        //         options: {
        //             yAxis: {
        //                 axisLabel: { show: window.IS_DESKTOP },
        //             },
        //         },
        //     });
        // };
        //
        // window.addEventListener('layoutChanged', updateChartLabels);
        // updateChartLabels();

        window.addEventListener('budgetChanged', () => {
            chart.setData({
                series: [
                    { name: 'Budget', data: EXTRA_DATA.planner.budget, color: '#A9AEB8'},
                    { name: 'Actual', data: EXTRA_DATA.planner.actual, color: '#50C3F7'},
                ],
            });
        });
    } catch (error) {
        // d(error);
    }
}

export function drawChartsForAnalytics()
{
    const charts = {};

    const formatChartDate = value => {
        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        const parts = String(value).match(/^([A-Za-z]{3})(?:\s+(\d{1,2}))?$/);
        const reversed = String(value).match(/^(\d{1,2})\s+([A-Za-z]{3})$/);

        const month = reversed ? reversed[2] : parts?.[1];
        const day = reversed ? Number(reversed[1]) : parts?.[2] ? Number(parts[2]) : null;

        const index = months.indexOf(month);

        if (index !== -1) {
            const date = new Date(Date.UTC(2026, index, day ?? 15, 12));

            return new Intl.DateTimeFormat(SYSTEM_LANGUAGE, {
                month: 'long',
                ...(day !== null ? { day: 'numeric' } : {}),
                timeZone: USER.timezone,
            }).format(date);
        }

        return value;
    };

    const createHorizontalChart = (items, {
        labelKey,
        valueKey,
        visibleRows = 7,
        valueFormatter = value =>
            document.body.classList.contains('privacy-mode')
                ? '***'
                : numberFormat(value),
    }) => {
        const maxValue = Math.max(
            0,
            ...items.map(item => Number(item[valueKey]))
        );

        return {
            type: 'custom',

            options: {
                grid: {
                    top: 10,
                    right: 24,
                    bottom: 20,
                    left: 10,
                },
                tooltip: {
                    trigger: 'axis',

                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            type: 'dashed',
                        },
                    },

                    formatter: params => {
                        const param = params[0];

                        return `${param.name}\n${valueFormatter(param.value[0])}`;
                    },
                },
                xAxis: {
                    type: 'value',
                    min: 0,
                    max: maxValue,
                    show: false,
                },

                yAxis: {
                    type: 'category',
                    data: items.map(item => item[labelKey]),
                    inverse: true,
                    show: false,
                },

                dataZoom: items.length > visibleRows ? [
                    {
                        type: 'inside',
                        yAxisIndex: 0,
                        startValue: 0,
                        endValue: visibleRows - 1,
                        zoomLock: true,
                    },
                    {
                        type: 'slider',
                        yAxisIndex: 0,
                        startValue: 0,
                        endValue: visibleRows - 1,
                        width: 8,
                        right: 0,
                    },
                ] : [],

                series: [
                    {
                        type: 'custom',

                        data: items.map((item, index) => [
                            Number(item[valueKey]),
                            index,
                        ]),

                        renderItem: (params, api) => {
                            const value = api.value(0);
                            const index = api.value(1);
                            const item = items[index];

                            const start = api.coord([0, index]);
                            const end = api.coord([value, index]);

                            const left = params.coordSys.x;
                            const right = left + params.coordSys.width;

                            const barHeight = 8;
                            const barY = start[1] + 5;

                            return {
                                type: 'group',

                                children: [
                                    {
                                        type: 'text',
                                        style: {
                                            x: left,
                                            y: start[1] - 8,
                                            text: item[labelKey],
                                            fill: '#F1F1F1',
                                            fontSize: 11,
                                            textAlign: 'left',
                                            textVerticalAlign: 'middle',
                                        },
                                    },
                                    {
                                        type: 'text',
                                        style: {
                                            x: right,
                                            y: start[1] - 8,
                                            text: valueFormatter(value),
                                            fill: '#F1F1F1',
                                            fontSize: 11,
                                            fontWeight: 'bold',
                                            textAlign: 'right',
                                            textVerticalAlign: 'middle',
                                        },
                                    },
                                    {
                                        type: 'rect',
                                        shape: {
                                            x: start[0],
                                            y: barY,
                                            width: Math.max(0, end[0] - start[0]),
                                            height: barHeight,
                                            r: 4,
                                        },
                                        style: {
                                            fill: item.color ?? '#50C3F7',
                                        },
                                    },
                                ],
                            };
                        },
                    },
                ],
            },
        };
    };

    const createDonutChart = (items, {
        labelKey,
        valueKey,
        totalLabel = __('analytics.label_total_spent'),
    }) => {
        const total = items.reduce(
            (sum, item) => sum + Number(item[valueKey]),
            0
        );

        const formattedTotal = numberFormat(total);

        const getTotalFontSize = value => {
            const length = value.length;

            if (length > 15) return 10;
            if (length > 12) return 12;
            if (length > 9) return 14;

            return 16;
        };

        return {
            type: 'donut',
            legend: false,
            // colors: ,
            categories: items.map(item => item[labelKey]),

            series: [
                {
                    name: __('label_spent'),
                    data: items.map(item => Number(item[valueKey])),

                    options: {
                        radius: window.IS_DESKTOP
                            ? ['55%', '75%']
                            : ['45%', '62%'],

                        label: {
                            show: true,
                            position: 'outside',

                            formatter: params => {
                                if (window.IS_DESKTOP) {
                                    return `{name|${params.name}}\n{percent|${params.percent}%}`;
                                }

                                if (params.percent < 2) {
                                    return '';
                                }

                                return `{percent|${params.percent}%}`;
                            },

                            rich: {
                                name: {
                                    color: '#A3A7AA',
                                    fontSize: 10,
                                    lineHeight: 16,
                                },
                                percent: {
                                    color: '#F1F1F1',
                                    fontSize: 11,
                                    fontWeight: 600,
                                },
                            },
                        },

                        labelLine: {
                            show: true,
                            length: window.IS_DESKTOP ? 10 : 6,
                            length2: window.IS_DESKTOP ? 8 : 4,
                        },
                    },
                },
            ],

            options: {
                graphic: [
                    {
                        type: 'group',
                        left: 'center',
                        top: 'center',

                        children: [
                            {
                                type: 'text',
                                style: {
                                    x: 0,
                                    y: -9,
                                    text: formattedTotal,
                                    privacyText: '***',
                                    fill: '#F1F1F1',
                                    fontSize: getTotalFontSize(formattedTotal),
                                    fontWeight: 600,
                                    textAlign: 'center',
                                    textVerticalAlign: 'middle',
                                },
                            },
                            {
                                type: 'text',
                                style: {
                                    x: 0,
                                    y: 10,
                                    text: totalLabel,
                                    fill: '#A3A7AA',
                                    fontSize: 11,
                                    textAlign: 'center',
                                    textVerticalAlign: 'middle',
                                },
                            },
                        ],
                    },
                ],
            },
        };
    };

    try {
        const categoryGroups = EXTRA_DATA.analytics.top_category_groups;

        charts.category_groups = new Charts(
            '#category_groups_chart',
            createDonutChart(categoryGroups, {
                labelKey: 'group_name',
                valueKey: 'total_amount',
            })
        );


        const categories = EXTRA_DATA.analytics.top_categories;

        charts.categories = new Charts(
            '#categories_chart',
            createDonutChart(categories, {
                labelKey: 'category_name',
                valueKey: 'spend',
            })
        );

        const spendDays = EXTRA_DATA.analytics.spend_days;

        const days = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ];

        const spendByDay = Object.fromEntries(
            spendDays.map(item => [
                item.day_of_week,
                Number(item.total_amount),
            ])
        );

        const normalizedSpendDays = days.map(day => ({
            name: __('day_' + day.toLowerCase()),
            amount: spendByDay[day] ?? 0,
        }));

        charts.spend_days = new Charts(
            '#spend_days_chart',
            createHorizontalChart(normalizedSpendDays, {
                labelKey: 'name',
                valueKey: 'amount',
                visibleRows: 7,
            })
        );

        const frequentCategories = EXTRA_DATA.analytics.top_categories_frequency;

        charts.category_frequency = new Charts(
            '#category_frequency_chart',
            {
                type: 'custom',
                legend: false,

                options: {
                    color: [
                        'rgba(80, 195, 247, 0.85)',
                        'rgba(255, 180, 84, 0.85)',
                        'rgba(104, 214, 160, 0.85)',
                        'rgba(182, 156, 255, 0.85)',
                        'rgba(255, 125, 145, 0.85)',
                    ],
                    tooltip: {
                        trigger: 'item',
                        formatter: params => {
                            return `${params.name}\n${params.value} ` + __('analytics.label_transaction' + (parseInt(params.value) > 1 ? 's' : ''));
                        }
                    },

                    series: [
                        {
                            type: 'treemap',

                            left: 16,
                            right: 16,
                            top: 0,
                            bottom: 16,

                            data: frequentCategories.map(item => ({
                                name: item.category_name,
                                value: Number(item.transaction_count),
                            })),

                            roam: false,
                            nodeClick: false,

                            breadcrumb: {
                                show: false,
                            },

                            levels: [
                                {},
                                {
                                    label: {
                                        show: true,
                                        color: '#252728',
                                        fontSize: 14,
                                        fontWeight: 'bold'
                                    },

                                    itemStyle: {
                                        borderColor: '#1C1C1D',
                                        borderWidth: 0.1,
                                        gapWidth: 0.1,
                                    },
                                },
                            ],
                        },
                    ],
                },
            }
        );

        const spendingOverTime = EXTRA_DATA.analytics.spending_over_time;

        const formatPeriod = (period, granularity) => {
            if (granularity === 'month') {
                const [year, month] = period.split('-');

                return new Date(
                    Number(year),
                    Number(month) - 1,
                    1
                ).toLocaleDateString(undefined, {
                    month: 'short',
                });
            }

            const date = new Date(`${period}T00:00:00`);

            return date.toLocaleDateString(undefined, {
                day: 'numeric',
                month: 'short',
            });
        };

        const granularity = spendingOverTime[0]?.granularity;

        charts.transaction_volume = new Charts('#transaction_volume_chart', {
            type: 'bar',
            legend: false,

            categories: spendingOverTime.map(
                item => formatPeriod(item.period, granularity)
            ),
            options: {
                xAxis: {
                    axisLabel: {
                        formatter: value => formatChartDate(value),
                    },
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: params => {
                        const date = formatChartDate(params[0].axisValue);

                        const lines = params.map(param =>
                            `${param.marker} ${(param.value === 1 ? __('analytics.label_transaction') : __('analytics.label_transactions'))}: ${param.value}`
                        );

                        return [date, ...lines].join("\n");
                    },
                },
            },
            series: [
                {
                    name: __('analytics.label_transactions'),
                    data: spendingOverTime.map(item => Number(item.transactions)),
                },
            ],

            valueFormatter: value => String(value),
        });
        const masterTrend = EXTRA_DATA.analytics.master_spending_trend;
        const currentBudgets = EXTRA_DATA.analytics.master_current_budget;
        const previousBudgets = EXTRA_DATA.analytics.master_previous_budget;

        const getBudget = (budgets, period) => {
            if (!period) {
                return 0;
            }

            const [year, month] = period.split('-').map(Number);

            const budget = budgets.find(item =>
                Number(item.year) === year &&
                Number(item.month) === month
            );

            return Number(budget?.budget ?? 0);
        };

        const getBudgetForDate = (budgets, date) => {
            const budget = budgets.find(item =>
                Number(item.year) === date.getFullYear() &&
                Number(item.month) === date.getMonth() + 1
            );

            return Number(budget?.budget ?? 0);
        };

        const getWeeklyBudget = (budgets, period) => {
            if (!period) {
                return 0;
            }

            const [year, month, day] = period.split('-').map(Number);
            const start = new Date(year, month - 1, day);

            let total = 0;

            for (let i = 0; i < 7; i++) {
                const date = new Date(start);
                date.setDate(start.getDate() + i);

                const monthlyBudget = getBudgetForDate(budgets, date);

                const daysInMonth = new Date(
                    date.getFullYear(),
                    date.getMonth() + 1,
                    0
                ).getDate();

                total += monthlyBudget / daysInMonth;
            }

            return total;
        };

        let currentTotal = 0;
        let previousTotal = 0;

        const masterTrendData = masterTrend.map(item => {
            let current = Number(item.current_spending);
            let previous = Number(item.previous_spending);

            if (granularity === 'day') {
                currentTotal += current;
                previousTotal += previous;

                current = currentTotal;
                previous = previousTotal;
            }

            return {
                period: item.period,
                previousPeriod: item.previous_period,
                current,
                previous,
                currentBudget: 0,
                previousBudget: 0,
            };
        });

        /*
         * Daily
         *
         * Spending is cumulative, so budget is also shown as
         * cumulative budget pace.
         */
        if (granularity === 'day' && masterTrendData.length) {
            const currentBudget = Number(currentBudgets[0]?.budget ?? 0);
            const previousBudget = Number(previousBudgets[0]?.budget ?? 0);

            const [currentYear, currentMonth] =
                masterTrendData[0].period.split('-').map(Number);

            const [previousYear, previousMonth] =
                masterTrendData[0].previousPeriod.split('-').map(Number);

            const currentDaysInMonth = new Date(
                currentYear,
                currentMonth,
                0
            ).getDate();

            const previousDaysInMonth = new Date(
                previousYear,
                previousMonth,
                0
            ).getDate();

            masterTrendData.forEach((item, index) => {
                const day = index + 1;

                item.currentBudget =
                    currentBudget * (day / currentDaysInMonth);

                item.previousBudget =
                    previousBudget * (day / previousDaysInMonth);
            });
        }

        /*
         * Weekly
         *
         * Spending is per week, so allocate the monthly budget
         * proportionally to the seven days represented by the week.
         */
        else if (granularity === 'week') {
            masterTrendData.forEach(item => {
                item.currentBudget = getWeeklyBudget(
                    currentBudgets,
                    item.period
                );

                item.previousBudget = getWeeklyBudget(
                    previousBudgets,
                    item.previousPeriod
                );
            });
        }

        /*
         * Monthly
         *
         * Spending is per month, so use the actual monthly budget.
         */
        else if (granularity === 'month') {
            masterTrendData.forEach(item => {
                item.currentBudget = getBudget(
                    currentBudgets,
                    item.period
                );

                item.previousBudget = getBudget(
                    previousBudgets,
                    item.previousPeriod
                );
            });
        }

        const budgetLabel =
            granularity === 'month'
                ? __('analytics.label_current_budget')
                : __('analytics.label_budget_pace');

        const previousBudgetLabel =
            granularity === 'month'
                ? __('analytics.label_previous_budget')
                : __('analytics.label_previous_budget_pace');

        charts.master_spending_trend = new Charts(
            '#master_spending_trend_chart',
            {
                type: 'area',
                smooth: true,
                legend: true,

                categories: masterTrendData.map(
                    item => formatPeriod(item.period, granularity)
                ),

                series: [
                    {
                        name: __('analytics.label_current_spending'),
                        data: masterTrendData.map(item => item.current),
                        color: '#50C3F7'
                    },
                    {
                        name: __('analytics.label_previous_spending'),
                        data: masterTrendData.map(item => item.previous),
                        color: '#FFB454',

                        options: {
                            lineStyle: {
                                type: 'dashed',
                            },

                            areaStyle: {
                                opacity: 0,
                            },
                        },
                    },
                    {
                        name: budgetLabel,
                        data: masterTrendData.map(item => item.currentBudget),
                        color: '#68D6A0',

                        options: {
                            lineStyle: {
                                width: 2,
                            },

                            areaStyle: {
                                opacity: 0,
                            },

                            symbol: 'none',
                        },
                    },
                    {
                        name: previousBudgetLabel,
                        data: masterTrendData.map(item => item.previousBudget),
                        color: '#B69CFF',

                        options: {
                            lineStyle: {
                                type: 'dashed',
                                width: 2,
                            },

                            areaStyle: {
                                opacity: 0,
                            },

                            symbol: 'none',
                        },
                    },
                ],
                options: {
                    xAxis: {
                        axisLabel: {
                            formatter: value => formatChartDate(value),
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: params => {
                            const date = formatChartDate(params[0].axisValue);

                            const lines = params.map(param =>
                                `${param.marker} ${param.seriesName}: ${(document.body.classList.contains('privacy-mode') ? '***' : numberFormat(param.value))}`
                            );

                            return [date, ...lines].join("\n");
                        },
                    },
                    media: [
                        {
                            query: {
                                maxWidth: 600,
                            },
                            option: {
                                legend: {
                                    show: false,
                                },
                                grid: {
                                    bottom: 12,
                                },
                            },
                        },
                        {
                            query: {
                                minWidth: 601,
                            },
                            option: {
                                legend: {
                                    show: true,
                                },
                                grid: {
                                    bottom: 44,
                                },
                            },
                        },
                    ],
                },
            }
        );
    } catch (error) {
        // d(error);
    }

    try {
        const incomeCategories = EXTRA_DATA.analytics.income_distribution.top_categories ?? [];

        charts.incomeDistribution = new Charts(
            '#income_distribution_chart',
            createDonutChart(incomeCategories, {
                labelKey: 'category_name',
                valueKey: 'amount',
                totalLabel: __('analytics.label_total_income')
            })
        );

        const momentum = EXTRA_DATA.analytics.income_momentum ?? {};

        const items = [
            ...(momentum.fastest_growing_categories ?? []),
            ...(momentum.fastest_declining_categories ?? [])
        ];

        charts.incomeMomentumChart = new Charts('#income_momentum_chart', {
            type: 'horizontalBar',
            legend: false,
            stack: true,
            categories: items.map(item => item.category_name),
            colors: ['#68D6A0', '#FF7D91'],
            series: [
                {
                    name: __('analytics.label_growing'),
                    data: items.map(item =>
                        Math.max(0, Number(item.absolute_change) || 0)
                    )
                },
                {
                    name: __('analytics.label_declining'),
                    data: items.map(item =>
                        Math.min(0, Number(item.absolute_change) || 0)
                    )
                }
            ]
        });

        const earningDays = EXTRA_DATA.analytics.income_top_earnings_days ?? [];

        charts.incomeEarningDaysChart = new Charts('#top_earning_days_chart', {
            type: 'horizontalBar',
            legend: false,
            categories: earningDays.map(item => item.day_of_week),
            series: [{
                name: __('label_income'),
                data: earningDays.map(item => Number(item.total_amount))
            }],
            colors: ['#50C3F7']
        });

        const frequency = EXTRA_DATA.analytics.income_categories_frequency ?? [];

        charts.incomeFrequencyChart = new Charts('#income_frequency_chart', {
            type: 'custom',
            legend: false,
            options: {
                tooltip: {
                    trigger: 'item',
                    formatter: params => {
                        return `${params.name}\n${params.value} ` + __('analytics.label_transaction' + (parseInt(params.value) > 1 ? 's' : ''));
                    }
                },
                series: [{
                    type: 'treemap',
                    left: 16,
                    right: 16,
                    top: 0,
                    bottom: 16,
                    roam: false,
                    nodeClick: false,
                    breadcrumb: { show: false },
                    data: frequency.map(item => ({
                        name: item.category_name,
                        value: Number(item.transaction_count)
                    })),
                    levels: [
                        {},
                        {
                            label: {
                                show: true,
                                color: '#252728',
                                fontSize: 14,
                                fontWeight: 'bold'
                            },

                            itemStyle: {
                                borderColor: '#1C1C1D',
                                borderWidth: 0.1,
                                gapWidth: 0.1,
                            },
                        },
                    ],
                }]
            }
        });

        // const updateChartLabels = () => {
        //     charts.incomeMomentumChart.update({
        //         options: {
        //             xAxis: {
        //                 axisLabel: { show: window.IS_DESKTOP },
        //             },
        //         },
        //     });
        //
        //     charts.incomeEarningDaysChart.update({
        //         options: {
        //             xAxis: {
        //                 axisLabel: { show: window.IS_DESKTOP },
        //             },
        //         },
        //     });
        // };
        //
        // window.addEventListener('layoutChanged', updateChartLabels);
        // updateChartLabels();
    } catch (error) {
        // d(error);
    }

    window.addEventListener('privacyToggled', () => {
        Object.values(charts).forEach(chart => chart?.update?.());
    });
}